import React from 'react'

function TermsFR() {
  return (
    <>
      <div className="paragraph-2">
        <p>
          Ces CGV s'appliquent pour tout contrat vendu par la société
          VideoAgency dont le siège social se situe à Paris. Pour tout contrat
          conclu avec Skeepers Inc., filiale de VideoAgency, merci de vous
          référer aux CGV accessibles en suivant le lien suivant :{' '}
          <a href="/terms?locale=en-US">CGV US</a>
        </p>
      </div>

      <p className="heading-1">CONDITIONS GENERALES D'UTILISATION DU SITE</p>

      <div className="paragraph-2">
        <p>
          Les présentes conditions générales ("CGU"), ont vocation à régir votre
          accès et utilisation du site (ci-après, le "Site") accessible à
          l'adresse URL suivante :{' '}
          <a href="/" target="_blank" rel="noopener noreferrer">
            https://www.octoly.com/
          </a>{' '}
          en qualité de particulier ou de professionnel ("Vous" ou "Votre" le
          cas échéant).
        </p>
        <p>
          Toute référence dans les CGU, sauf dispositions contraires, à
          "Skeepers" estprésumée inclure Skeepers et toutes ses filiales.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">1. Présentation du Site</p>
        <p>
          Le Site est une interface de présentation et d'accès à une plateforme
          développée par Skeepers et exploitée sous la marque protégée Skeepers
          conçue pour permettre à des partenaires détenant et/ou commercialisant
          des produits tels que des produits cosmétiques et des jeux vidéo et/ou
          de tout autre type de produits et/ou services (les "Partenaires")
          d'être mis en relation avec des consommateurs et des influenceurs
          ayant un compte Skeepers (les "Contributeurs") afin qu'ils testent
          certains produits des Partenaires, et publient une évaluation ou une
          revue vidéo dudit test sur leur compte youtube et/ou instagram ainsi
          que sur les sites internet des Partenaires.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Accès au Site</p>
        <p className="tc-neutral900 ml-16">2.1. Utilisateurs du Site</p>
        <p>
          Votre accès ou votre utilisation du Site emporte Votre acceptation
          expresse et sans réserve des CGU, incluant notamment la{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            politique de confidentialité
          </a>
          . Si Vous accédez ou utilisez le Site en qualité de professionnel,
          vous garantissez à Skeepers que Vous détenez l'intégralité des droits,
          des autorisations et des pouvoirs nécessaires pour accepter les CGU au
          nom de la société, association, partenaire ou tout autre entité pour
          laquelle Vous utilisez ou accédez au Site.
        </p>

        <p className="tc-neutral900 ml-16">
          2.2. Utilisation et accès du Site en tant que Partenaire
        </p>
        <p>
          Vous pouvez souscrire à un abonnement par voie contractuelle avec
          Skeepers pour avoir accès au Site en tant que Partenaire pour Vous
          permettre notamment d'analyser les données relatives à l'activité des
          influenceurs sur les réseaux sociaux, afin de mesurer leur influence
          sociale ainsi que leurs compétences dans certains domaines spécifiques
          et de répertorier les évaluations des consommateurs publiées
          directement sur Votre site internet (ci-après les "Services").
        </p>

        <p className="tc-neutral900 ml-16">
          2.3. Utilisation et accès au Site en tant que Contributeur
        </p>
        <p>
          Vous pouvez Vous enregistrer sur le Site en tant que Contributeur
          suite à Votre acceptation éclairée des conditions spécifiques
          d'utilisation du Site pour les Contributeurs (disponible à l'adresse
          URL suivante :{' '}
          <a
            href="/conditions-for-contributors"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://app.im.skeepers.io/conditions-for-contributors/
          </a>
          ). En tant que Contributeur, Vous Vous engagez à remplir le formulaire
          d'inscription avec des renseignements exacts, à jours et complets et
          de les mettre à jour en cas de changement. Les données d'inscription
          et certains autres renseignements concernant les données renseignées
          par les Contributeurs sont régis par la{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            politique de Confidentialité
          </a>
          .
        </p>
        <p>
          Skeepers utilise l'API de Youtube notamment pour authentifier et lier
          votre chaine Youtube à votre compte Contributeurs sur le Site. En
          conséquence, en utilisant le Site, Vous acceptez expressément les
          conditions d'utilisation de Youtube disponible à l'adresse URL
          suivante :{' '}
          <a
            href="https://www.youtube.com/t/terms/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.youtube.com/t/terms/
          </a>
          .
        </p>

        <p className="tc-neutral900 ml-16">2.4. Réserve</p>
        <p>
          Skeepers se réserve le droit, à son entière discrétion, de limiter
          l'accès aux Services, d'interdire l'accès au Site, et/ou de résilier
          le compte de tout Contributeurs et/ou Partenaire qui violerait les
          CGU, la loi applicable et/ou les droits de tout tiers tels que des
          droits de la propriété intellectuelle.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Propriété intellectuelle</p>
        <p className="tc-neutral900 ml-16">
          3.1. Relative au Site et aux Marques de Skeepers
        </p>
        <p>
          En tant qu'Utilisateur du Site, Partenaire et/ou Contributeur, Vous
          reconnaissez et acceptez que le Site et les Services puissent contenir
          certains éléments, matériels et contenus (ci-après le "Contenu du
          Site") protégés par des droits d'auteur, des brevets, des marques, le
          secret commercial ou d'autres droits de propriété intellectuelle, et
          notamment des marques protégées appartenant à des tiers.
        </p>
        <p>
          Sauf accord exprès de Skeepers, en tant qu'Utilisateur du Site,
          Partenaire et/ou Contributeur, Vous acceptez de ne pas modifier,
          copier, louer, prêter, vendre, distribuer ou créer toute œuvre dérivée
          du Contenu du Site, en tout ou partie, ni de procéder ou d'utiliser
          des systèmes d'extraction et/ou collecte de données.
        </p>
        <p>
          Le nom et les logos de Skeepers sont des marques détenues par Skeepers
          (ci-après collectivement les "Marques de Skeepers"). Les autres noms
          et logos des produits et services de Skeepers utilisés dans le cadre
          des Services sont des marques appartenant à leurs propriétaires
          respectifs, qui peuvent être affiliés ou non à Skeepers.
        </p>
        <p>
          Aucune stipulation des CGU ni aucun contenu des Services ne sauraient
          être interprétés comme l'octroi, de façon implicite ou autrement, de
          toute licence ou droit d'utiliser les Marques de Skeepers, sans
          l'autorisation écrite de Skeepers dans chaque cas.
        </p>

        <p className="tc-neutral900 ml-16">
          3.2. Relative au contenu des tiers
        </p>
        <p>
          Les Partenaires et/ou les Contributeurs peuvent mettre en ligne des
          marques, matériels, contenus vidéos et/ou photographiques (ensemble
          les "Contenus Tiers") via leur compte Skeepers sous leur seule
          responsabilité.
        </p>
        <p>
          Skeepers ne saurait en aucun cas être tenue pour responsable, de
          quelconque manière, des Contenus Tiers mis en ligne sur le Site, y
          compris, mais sans s'y limiter, pour toute plainte d'un tiers relative
          au Contenu Tiers, toute erreur ou omission d'un Contenu Tiers, ou pour
          toute perte ou dommage d'un Contenu Tiers ou provoquée par
          l'utilisation d'un Contenu Tiers.
        </p>
        <p>
          Skeepers ne monitore pas le Site et/ou la Plateforme mais se réserve
          le droit de retirer tout Contenu Tiers qui contreviendrait aux CGU ou
          qui ne respecterait pas la loi applicable, y compris qui violerait un
          droit de propriété intellectuelle, dès lors que Skeepers aurait eu
          connaissance de l'illicéité dudit Contenu. À cet effet, Skeepers
          invite tout Utilisateur, Partenaire et/ou Contributeur à contacter{' '}
          <a
            href="https://skeepers-octoly.zendesk.com/hc/en-150/requests/new?ticket_form_id=5486073315740"
            target="_blank"
            rel="noopener noreferrer"
          >
            Skeepers
          </a>{' '}
          s'il estime qu'un Contenu Tiers viole l'un de ses droits et/ou la loi
          applicable et suivant les formalismes imposés par la loi concernant
          les demandes de retrait de contenu illicite. Après réception d'une
          demande de retrait valide au regard des lois applicables, Skeepers
          retirera promptement le Contenu Tiers visé par cette demande.
        </p>
        <p>
          Vous devez évaluer et supporter les risques liés à l'utilisation de
          tout Contenu Tiers, notamment concernant l'exactitude, la complétude
          ou l'utilité d'un tel Contenu Tiers.
        </p>
        <p>
          Vous reconnaissez et acceptez que toutes questions, commentaires,
          suggestions, idées, impressions ou autres informations à propos des
          Services (ci-après les "Propositions"), que vous fournissez à
          Skeepers, ne sont pas confidentiels et que cette dernière est en droit
          d'utiliser et de diffuser, sans restriction, ces Propositions, à toute
          fin, commerciale ou autre, sans qu'aucune reconnaissance ou
          compensation quelle qu'elle soit ne vous soit due.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">4. Disponibilité du Site</p>
        <p>
          Skeepers ne garantit aucunement que le Site soit accessible en
          continu. Skeepers se réserve le droit de modifier, suspendre et/ou
          supprimer tout ou partie du Site et des informations qu'ils
          contiennent à tout moment et ce, sans préavis. Par conséquent,
          Skeepers ne saurait être tenue pour responsable de tout dommage avéré
          ou allégué, subi directement ou indirectement, par tout Utilisateur,
          Contributeur et/ou Partenaire, lié à la connexion, la consultation
          et/ou l'utilisation des informations fournies par le Site.
        </p>
        <p>
          Si Votre accès au Site est bloqué par Skeepers (notamment en bloquant
          Votre adresse IP), Vous acceptez de ne pas mettre en place quelconque
          mesure visant à contourner un tel blocage (par exemple en masquant
          Votre adresse IP ou en utilisant l'adresse IP d'un mandataire).
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">5. Modifications des CGU</p>
        <p>
          Skeepers se réserve le droit de modifier à tout moment les CGU ainsi
          que la{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            politique de confidentialité.
          </a>{' '}
          Dans cette hypothèse, ces modifications feront l'objet d'une mention
          particulière au sein du Site. Vous reconnaissez et acceptez que votre
          utilisation du Site ou simplement votre accès à celui-ci après la date
          des modifications, emportera votre acceptation des CGU et{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            politique de confidentialité
          </a>{' '}
          telles que modifiées.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">6. Litige</p>
        <p>
          Le Site et les CGU sont régis par le droit français, quel que soit
          Votre lieu d'utilisation du Site. En cas de contestation éventuelle
          les tribunaux de Marseille, France, seront seuls compétents pour
          connaître de ce litige.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline uppercase">
          QUESTIONS ? PROBLEMES ? SUGGESTIONS ?
        </p>
        <p>
          Nous vous prions de nous contacter{' '}
          <a
            href="https://skeepers-octoly.zendesk.com/hc/en-150/requests/new?ticket_form_id=5486073315740"
            target="_blank"
            rel="noopener noreferrer"
          >
            ici
          </a>{' '}
          ou par courrier à Skeepers, 18-20 Avenue Robert Schuman CS 40494 13002
          Marseille afin de signaler toute violation des CGU ou pour poser toute
          question concernant ces CGU ou les Services.
        </p>
      </div>
    </>
  )
}

export default TermsFR
